import produce from "immer";
import { CustomizationState } from "../";
import { changeElementFontKey } from "./changeEditableTextElementFont";

export interface ChangeAllPagesFontDefinitionAction {
  type: "changeAllPagesFontDefinition";
  fontDefinitionKey: string;
}

export function changeAllPagesFontDefinition(
  state: CustomizationState,
  action: ChangeAllPagesFontDefinitionAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content } = draftState;
    const { fontDefinitionKey } = action;

    draftState.ui.defaultFontKey = fontDefinitionKey;

    for (const page of content.pages) {
      for (const editableText of page.editableTexts) {
        changeElementFontKey(state, draftState, fontDefinitionKey, page, editableText);
      }
    }
  });
}
